import { FlexColumn } from '@gorila-shared-ui/components';
import { useRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { editUserState } from '../../../storage/userStates';
import { UserRequest } from '../../../types/users';
import { SkillListPicker } from '../../jobs/skills/SkillListPicker';

export function UserSkillFields() {
  const { css } = useStyles();
  const [form, setForm] = useRecoilState(editUserState);

  const onChangeInput = (key: keyof UserRequest, value: any) => {
    setForm((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <FlexColumn
      classNames={css({
        minHeight: '450px',
      })}
    >
      <SkillListPicker
        assignedSkills={form.skills}
        onAssignedChange={(skills) => onChangeInput('skills', skills)}
        required
      />
    </FlexColumn>
  );
}
